import { TextField } from '@lego/connect-components-react';

/**
 * Returns a `renderEndEnhancer` callback that shows a link icon when `isLinked` is true.
 * Use with `NumericTextField` or `TextField` to indicate inherited/linked values.
 */
export const linkedEnhancer = (isLinked: boolean) =>
  isLinked
    ? () => <TextField.Enhancer iconName="link" aria-label="Inherited" />
    : undefined;
